/*
 * Ouverture du tiroir de panier depuis l'icone de l'en-tete.
 *
 * Dawn cable son propre declencheur sur `#cart-icon-bubble`. Cet en-tete
 * n'utilise pas ce balisage, et lui donner cet identifiant serait pire que le
 * probleme : le tiroir remplace le contenu de cet element a chaque ajout, par
 * son propre gabarit de pastille — l'icone du panier disparaitrait au premier
 * article.
 *
 * On cable donc notre lien nous-memes. Il reste un <a href="/cart"> : sans
 * JavaScript, ou si le reglage repasse sur « page », le clic mene a la page
 * panier comme avant. Le tiroir n'est qu'un raccourci par-dessus.
 */
(() => {
  const lien = document.querySelector('.entete__action--panier');
  if (!lien) return;

  const tiroir = document.querySelector('cart-drawer');
  if (!tiroir) return;

  /* On attend que l'element personnalise soit DEFINI avant de cabler.
   *
   * Les deux scripts sont differes : au moment ou celui-ci s'execute,
   * <cart-drawer> peut n'etre encore qu'une balise inconnue, sans methode
   * `open`. Une verification a l'instant du chargement echouait donc au
   * hasard de l'ordre de chargement, et le lien retombait sur la page panier.
   *
   * `whenDefined` supprime la course. Si l'element n'est jamais defini —
   * script absent, erreur amont — rien n'est cable et le lien continue de
   * mener a /cart. */
  customElements.whenDefined('cart-drawer').then(() => {
    if (typeof tiroir.open !== 'function') return;
    cabler();
  });

  function cabler() {
  // `role` et `aria-haspopup` disent ce que le lien fait reellement une fois
  // le script en place : il n'emmene plus sur une autre page, il ouvre un
  // panneau sur celle-ci.
  lien.setAttribute('role', 'button');
  lien.setAttribute('aria-haspopup', 'dialog');

  lien.addEventListener('click', (evenement) => {
    // Le clic milieu et les clics avec modificateur gardent leur sens :
    // ouvrir la page panier dans un nouvel onglet reste possible.
    if (evenement.metaKey || evenement.ctrlKey || evenement.shiftKey) return;

    evenement.preventDefault();
    if (typeof tiroir.setActiveElement === 'function') tiroir.setActiveElement(lien);
    tiroir.open(lien);
  });

  lien.addEventListener('keydown', (evenement) => {
    if (evenement.code && evenement.code.toUpperCase() === 'SPACE') {
      evenement.preventDefault();
      tiroir.open(lien);
    }
  });
  }
})();
